import { RouteConfig } from "vue-router";

export const RRemoveTeammate: RouteConfig = {
  path: ":teammateId(\\d+)",
  name: "RemoveTeammate",
  component: () =>
    import(
      /* webpackChunkName: "remove-teammate" */
      "./VRemoveTeammate.vue"
    ),
  meta: {
    backLink: "/teammates",
  },
};
